// エラー時に #contact-form へスムーススクロール
document.addEventListener('DOMContentLoaded', function () {
  // バリデーションエラー・スパム判定・送信失敗時にスクロール
  document.addEventListener('wpcf7invalid', scrollToContact, false);
  document.addEventListener('wpcf7spam', scrollToContact, false);
  document.addEventListener('wpcf7mailfailed', scrollToContact, false);

  function scrollToContact() {
    const target = document.querySelector('#contact-form');
    if (target) {
      target.scrollIntoView({
        behavior: 'smooth', // スムーススクロール
        block: 'start'      // 要素の上端に合わせる
      });
    }
  }
});

// 送信完了時にページ遷移
document.addEventListener('DOMContentLoaded', function () {
  document.addEventListener('wpcf7mailsent', function (event) {
    // 遷移先URLを指定
    window.location.href = '/wp/contact/thanks/'; // 例: サンクスページ
  }, false);
});
